import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import ContactUs from "../components/ContactUs";
//import useFaqs from "../Hooks/useFaqs";
//import ComFaqs from '../components/ComFaqs';


const Contactus = () =>{
    
    return (
    <div>
      <ContactUs />
    </div>
    );

}
export default Contactus;